export default "__VITE_ASSET__DTXyteti__"